import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { AlertController, LoadingController, ModalController } from '@ionic/angular';
import { CreateUserDto, UserServiceProxy, FarmerCreateDto, FarmerServiceServiceProxy, RegistrationTokenServiceServiceProxy, RegistrationTokenDto, TokenAuthServiceProxy, AuthenticateModel, SecurityQuestionDto, SecurityQuestionServiceServiceProxy, UserSecurityQuestionAnswer, UserSecurityQuestionAnswerServiceServiceProxy, ServiceProxy, CaptchaModel } from '@shared/service-proxies/service-proxies';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { LoginService } from '../login/login.service';
import { Title } from '@angular/platform-browser';
import { UserNameValidator } from './user-name.validator';
import { EmailValidator } from './email.validator';
import { CaptchaComponent } from 'angular-captcha';
import { AppConsts } from '@shared/AppConsts';
import { Observable } from 'rxjs/internal/Observable';
import { SecurityQuestionPage } from './security-question/security-question.page';

@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RegisterPage implements OnInit {

  token: string;
  registrationToken: RegistrationTokenDto;
  passwordType: string = 'password';
  passwordIcon: string = 'eye-off';
  passwordConfirmType: string = 'password';
  passwordConfirmIcon: string = 'eye-off';
  formGroup: FormGroup;
  securityQuestions: SecurityQuestionDto[];
  availableSecurityQuestions1: SecurityQuestionDto[];
  availableSecurityQuestions2: SecurityQuestionDto[];
  userSecurityQuestionAnswers: UserSecurityQuestionAnswer[]; // = [
  //   {
  //     id: null,
  //     answer: null,
  //     securityQuestion: { id: null, label: null, init: null, toJSON: null, clone: null },
  //     securityQuestionId: null,
  //     user: null,
  //     userId: null,
  //     init: null,
  //     toJSON: null,
  //     clone: null
  //   },
  //   {
  //     id: null,
  //     answer: null,
  //     securityQuestion: { id: null, label: null, init: null, toJSON: null, clone: null },
  //     securityQuestionId: null,
  //     user: null,
  //     userId: null,
  //     init: null,
  //     toJSON: null,
  //     clone: null
  //   }
  // ];
  
  private baseUrl: string = AppConsts.remoteServiceBaseUrl;
  @ViewChild(CaptchaComponent, { static: true }) captchaComponent: CaptchaComponent;

  customAlertOptions: any = {
    cssClass: 'security-question-alert'
  };

  constructor(
    private formBuilder: FormBuilder,
    private alertController: AlertController,
    private userService: UserServiceProxy,
    private farmerSvc: FarmerServiceServiceProxy,
    private loadingController: LoadingController,
    private router: Router,
    private route: ActivatedRoute,
    private registrationSvc: RegistrationTokenServiceServiceProxy,
    private _tokenAuthService: TokenAuthServiceProxy,
    private loginService: LoginService,
    private titleService: Title,
    private securityQuestionSvc: SecurityQuestionServiceServiceProxy,
    private userSecurityQuestionAnswerSvc: UserSecurityQuestionAnswerServiceServiceProxy,
    private http: HttpClient,
    private modalController: ModalController
    // private captchaSvc: ServiceProxy
  ) {
    this.route.queryParams.subscribe(params => {
      // if (params && params.token) {
      //   this.token = params.token;
      //   if (this.token) {
      //     this.getUserRegistration();
      //   } else {
      //     this.initializeNewRegistration();
      //   }
      // } else {
      //  this.initializeNewRegistration();
      // }
      this.setupForm();
      this.getSecurityQuestions();
    });
    this.titleService.setTitle('OACI - Register');
  }

  setupForm() {
    if (this.formGroup) {
      this.formGroup.reset();
    }
    this.formGroup = this.formBuilder.group({
      firstName: ['', /*this.token ? */Validators.required/* : null*/],
      lastName: ['', /*this.token ? */Validators.required/* : null*/],
      userName: ['', /*this.token ? */[Validators.required, UserNameValidator.isValid]/* : null*/],
      emailAddress: ['', [Validators.required, EmailValidator.isValid]/*, Validators.email*/],
      // emailAddressConfirm: ['', [Validators.required, EmailValidator.isValid]/*, Validators.email*/],
      password: ['', /*this.token ? */[Validators.required,Validators.minLength(5)]/* : null*/],
      passwordConfirm: ['', /*this.token ? */[Validators.required,Validators.minLength(5)]/* : null*/]
    });
    const uSQA1 = new UserSecurityQuestionAnswer();
    uSQA1.id = 1;
    // uSQA1.securityQuestion = { id: null, label: null, init: null, toJSON: null, clone: null };
    const uSQA2 = new UserSecurityQuestionAnswer();
    uSQA2.id = 2;
    // uSQA2.securityQuestion = { id: null, label: null, init: null, toJSON: null, clone: null };
    this.userSecurityQuestionAnswers = [uSQA1, uSQA2];
  }

  getSecurityQuestions() {
    this.securityQuestionSvc.getAll().subscribe(questions => {
      this.securityQuestions = questions;
      this.availableSecurityQuestions1 = JSON.parse(JSON.stringify(questions));
      this.availableSecurityQuestions2 = JSON.parse(JSON.stringify(questions));
    });
  }

  // getUserRegistration() {
  //   this.registrationSvc.getByToken(this.token).subscribe(async registrationToken => {
  //     if (registrationToken) {
  //       this.registrationToken = registrationToken;
  //       this.formGroup.patchValue({
  //         'emailAddress': this.registrationToken.emailAddress,
  //         'emailAddressConfirm': this.registrationToken.emailAddress
  //       });
  //       if (
  //         !this.registrationToken.isActive ||
  //         this.registrationToken.expirationDate < moment()
  //       ) {
  //         this.formGroup.disable();

  //         const alert = await this.alertController.create({
  //           header: 'Error',
  //           message: 'This registration token is expired and/or in-active.',
  //           buttons: [
  //             {
  //               text: 'Okay',
  //               handler: () => {
  //                 this.router.navigate(['/account/login']);
  //               }
  //             }
  //           ]
  //         });

  //         await alert.present();
  //       }
  //     }
  //   });
  // }

  ngOnInit() {
    this.captchaComponent.captchaEndpoint = this.baseUrl + '/simple-captcha-endpoint.ashx';
  }

  ionViewWillEnter() {
    this.setupForm();
  }

  async submitForm() {
    if (this.isValid()) {
      const alert1 = await this.alertController.create({
        header: 'Registration Confirmation',
        message: 'The information you have entered including your email is correct?<br><br>Email: ' + this.formGroup.controls.emailAddress.value,
        buttons: [
          {
            text: 'No',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              
            }
          }, {
            text: 'Yes',
            handler: async () => {
              // const alert2 = await this.alertController.create({
              //   header: 'Registration Confirmation',
              //   message: 'Are you sure the information you have entered including your email is correct?<br><br>Email: ' + this.formGroup.controls.emailAddress.value,
              //   buttons: [
              //     {
              //       text: 'No',
              //       role: 'cancel',
              //       cssClass: 'secondary',
              //       handler: (blah) => {
                      
              //       }
              //     }, {
              //       text: 'Yes',
              //       handler: () => {
                      this.registerUser().then();
              //       }
              //     }
              //   ]
              // });
              // await alert2.present();
            }
          }
        ]
      });
      await alert1.present();
    } else {
      // const errorMessages = [];
      // if (!this.formGroup.valid) errorMessages.push('&#183; Missing Form Fields.');
      // if (!this.passwordsMatch()) errorMessages.push('&#183; Passwords do not match.');
      // const alert = await this.alertController.create({
      //   header: 'Error',
      //   // subHeader: 'Error',
      //   message: errorMessages.join('<br>'),
      //   buttons: ['OK']
      // });

      // await alert.present();
    }
  }

  passwordsMatch() { // stupid chrome autofill puts password value in
    return /*this.registrationToken ? */this.formGroup.controls.password.value == this.formGroup.controls.passwordConfirm.value/* : true*/;
  }

  async registerUser() {

    const loading = await this.loadingController.create({
      message: 'Registering user...',
    });
    await loading.present();

    // if (!this.token) {
    //   this.registrationSvc.create(this.formGroup.controls.emailAddress.value).subscribe(async repsonse => {
    //     if (repsonse) {
    //       await loading.dismiss();

    //       const alert = await this.alertController.create({
    //         header: 'Success',
    //         message: 'Please check your email for a confirmation link.',
    //         buttons: [
    //           {
    //             text: 'Okay',
    //             handler: () => {
    //               this.router.navigate(['/account/login']);
    //             }
    //           }
    //         ]
    //       });

    //       await alert.present();
    //     }
    //   });
    // } else {

      const user: CreateUserDto = this.formGroup.getRawValue();
      const fullName = user.firstName + ' ' + user.lastName;
      user.name = fullName;
      user.surname = fullName;
      user.fullName = fullName;
      user.isActive = true;
      user.sendPasswordResetLink = false;
      user.sendConfirmationEmail = true;
      this.userService.doesUserExist(user.userName).subscribe(async exist => {
        if (exist) {
          await loading.dismiss();

          const alert = await this.alertController.create({
            header: 'Error',
            message: 'This username is taken',
            buttons: [
              {
                text: 'Okay',
                handler: () => {

                }
              }
            ]
          });

          await alert.present();
        } else {
          var captchaPostData = { userEnteredCaptchaCode: null, captchaId: null }; // new CaptchaModel();
          captchaPostData.userEnteredCaptchaCode = this.captchaComponent.userEnteredCaptchaCode;
          captchaPostData.captchaId = this.captchaComponent.captchaId;
          this.captchaSend(captchaPostData).subscribe(
            async response => {
              if (response.success == false) {
                await loading.dismiss();

                this.captchaComponent.reloadImage();

                const alert = await this.alertController.create({
                  header: 'Error',
                  message: 'Captcha code was invalid. Try again.',
                  buttons: [
                    {
                      text: 'Okay',
                      handler: () => {
  
                      }
                    }
                  ]
                });
  
                await alert.present();
              } else {
                this.userService.create(user).subscribe(
                  userResponse => {
                    const farmer: FarmerCreateDto = new FarmerCreateDto();
                    farmer.userId = userResponse.id;
                    farmer.token = this.token;
                    this.farmerSvc.create(farmer).subscribe(
                      async farmerResponse => {
      
                        // fire and forget
                        this.userSecurityQuestionAnswers[0].userId = userResponse.id;
                        this.userSecurityQuestionAnswers[1].userId = userResponse.id;
                        this.userSecurityQuestionAnswerSvc.addAll(this.userSecurityQuestionAnswers).subscribe(() => {});
      
                        this.userService.sendConfirmationEmail(userResponse.id, farmerResponse.id).subscribe(() => {});
      
                        // this.registrationSvc.expireToken(this.token).subscribe(async tokenExpResponse => {
                          await loading.dismiss();
                          this.loginService.rememberMe = true;
                          this.loginService.authenticateModel = new AuthenticateModel({
                            password: user.password,
                            rememberClient: true,
                            userName: user.userName
                          });
                          this.loginService.postLoginPage = '/main/farmer';
                          this.loginService.authenticate().then().catch(async () => {
      
                            const alert = await this.alertController.create({
                              header: 'Success',
                              message: 'User has been registered but could not be logged in',
                              buttons: [
                                {
                                  text: 'Okay',
                                  handler: () => {
                                    this.router.navigate(['/account/login']);
                                  }
                                }
                              ]
                            });
      
                            await alert.present();
                          });
                        // });
                      },
                      error => {
                        console.log(error);
                      }
                    );
                  },
                  async error => {
                    await loading.dismiss();
      
                    const alert = await this.alertController.create({
                      header: 'Error',
                      message: 'There was an error registering new User',
                      buttons: [
                        {
                          text: 'Okay',
                          handler: () => {
      
                          }
                        }
                      ]
                    });
      
                    await alert.present();
                  }
                );
              }
          });
        }
      })
    // }
  }

  // initializeNewRegistration() {
  //   this.token = null;
  //   this.registrationToken = new RegistrationTokenDto();
  // }

  hideShowPassword() {
    this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
    this.passwordIcon = this.passwordIcon === 'eye-off' ? 'eye' : 'eye-off';
  }

  hideShowPasswordConfirm() {
    this.passwordConfirmType = this.passwordConfirmType === 'text' ? 'password' : 'text';
    this.passwordConfirmIcon = this.passwordConfirmIcon === 'eye-off' ? 'eye' : 'eye-off';
  }

  // emailsMatch() {
  //   return this.formGroup.controls.emailAddress.value == this.formGroup.controls.emailAddressConfirm.value;
  // }

  userNameMeetsRequirements() {
    let re = /^[a-zA-Z0-9]{3}[a-zA-Z0-9]*$/;
    return re.test(this.formGroup.controls.userName.value);
  }

  passwordsMatchAndMeetRequirements() {
    return this.formGroup.controls.password.value == this.formGroup.controls.passwordConfirm.value && this.formGroup.controls.password.value.length >= 5;
  }

  emailValid() {
    // const result = EmailValidator.isValid(<FormControl>this.formGroup.controls.emailAddress);
    // return !result['email:validation:fail'];
    let re = /^[a-zA-Z0-9._]+[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return re.test(this.formGroup.controls.emailAddress.value);
  }

  isValid() {
    return this.formGroup.valid && !this.hasError();
  }

  hasError() {
    // return this.formGroup.controls.emailAddress.value && !this.emailValid() ||
    //   this.formGroup.controls.emailAddressConfirm.value && !this.emailsMatch() ||
    return !this.emailValid() ||
      !this.userNameMeetsRequirements() ||
      // !this.emailsMatch() ||
      !this.passwordsMatchAndMeetRequirements() ||
      !this.userHasAnsweredAllQuestions() ||
      !this.hasEnteredCaptchaCode();
  }

  userHasSelctedAllQuestions() {
    return this.userHasSelctedQuestion(0) && this.userHasSelctedQuestion(1);
  }

  userHasSelctedQuestion(index) {
    return this.userSecurityQuestionAnswers[index].securityQuestionId != null;
  }

  userHasAnsweredAllQuestions() {
    return this.userHasAnsweredQuestion(0) && this.userHasAnsweredQuestion(1);
  }

  userHasAnsweredQuestion(index) {
    return this.userSecurityQuestionAnswers[index].answer != null;
  }

  securityQuestionOnChange(event, index: number) {
    this.userSecurityQuestionAnswers[index].answer = null;
    if (index == 0) {
      this.availableSecurityQuestions2 = JSON.parse(JSON.stringify(
        this.securityQuestions.filter(x => x.id != this.userSecurityQuestionAnswers[index].securityQuestionId)
      ));
    } else {
      this.availableSecurityQuestions1 = JSON.parse(JSON.stringify(
        this.securityQuestions.filter(x => x.id != this.userSecurityQuestionAnswers[index].securityQuestionId)
      ));
    }
  }

  
  // // Process the form on submit event.
  // validate(value, valid): void {

  //   // get the user-entered captcha code value to be validated at the backend side        
  //   let userEnteredCaptchaCode = this.captchaComponent.userEnteredCaptchaCode;

  //   // get the id of a captcha instance that the user tried to solve
  //   let captchaId = this.captchaComponent.captchaId;

  //   const postData = {
  //     userEnteredCaptchaCode: userEnteredCaptchaCode,
  //     captchaId: captchaId
  //   };

  //   // post the captcha data to the backend
  //   this.captchaSend(postData)
  //     .subscribe(
  //       response => {
  //         if (response.success == false) {
  //           // captcha validation failed; reload image
  //           this.captchaComponent.reloadImage();
  //           // TODO: maybe display an error message, too
  //         } else {
  //           // TODO: captcha validation succeeded; proceed with the workflow
  //         }
  //       });
  // }

  captchaSend(data: Object): Observable<any> {
    const options = {
      headers: new HttpHeaders(
        {'Content-Type': 'application/json; charset=utf-8'}
      )
    };

    return this.http.post(this.baseUrl + '/Captcha', data, options);
  }

  hasEnteredCaptchaCode() {
    return this.captchaComponent && this.captchaComponent.userEnteredCaptchaCode != null && this.captchaComponent.userEnteredCaptchaCode!= '';
  }

  async openSecurityQuestion(event, number) {
    event.preventDefault();
    event.stopPropagation();
    const questions = number == 1 ? this.availableSecurityQuestions1 : number == 2 ? this.availableSecurityQuestions2 : [];
    const modal = await this.modalController.create({
      component: SecurityQuestionPage,
      componentProps: {
        'number': number,
        'questions': questions,
      }
    });
    modal.onDidDismiss().then((param) => {
      if (param && param.data && param.data['question']) {
        if (number == 1) {
          // this.userSecurityQuestionAnswers[0].securityQuestion = param.data['question'];
          this.userSecurityQuestionAnswers[0].securityQuestionId = param.data['question'].id;
        } else if (number == 2) {
          // this.userSecurityQuestionAnswers[1].securityQuestion = param.data['question'];
          this.userSecurityQuestionAnswers[1].securityQuestionId = param.data['question'].id;
        } else {

        }
        this.securityQuestionOnChange(null, --number);
      }
    });
    return await modal.present();
  }

  getUserSecurityQuestionLabel(index) {
    if (this.userSecurityQuestionAnswers[index].securityQuestionId) {
      return this.securityQuestions.find(x => x.id == this.userSecurityQuestionAnswers[index].securityQuestionId).label;
    } else {
      return '';
    }
  }

}
